import cx from 'classnames';
import React from 'react';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import { Panel as Panel_ } from '../panel';

const Container = styled(Panel_)`
  max-width: calc(var(--content-width) / 2);

  .title {
    padding-bottom: 8px;
    display: flex;
    align-items: left;
    justify-content: left;

  }
`;

export const Panel = ({ className, children, title, ...rest }: Panel.Props): ReactElement => (
  <Container className={cx('mx-auto', 'px-24px', 'py-32px', className)} {...rest} id='auth-panel'>
    {title && <h1 className='title'>{title}</h1>}
    {children}
  </Container>
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace Panel {
  export type Props = React.PropsWithChildren<{
    className?: string;
    title?: string;
  }>;
}
